<template>
  <div>
    <h2>PreviewSubpage</h2>
  </div>
</template>

<script>
export default {
  name: "PreviewSubpage",
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  components: {
  }
};
</script>

<style>
</style>
